export interface SettingsInformationVm {
    termsOfUse: string;
    blockedAccount: string;
    maxSizeAttachment: number;
    specialSituationMessage: SpecialSituationMessageVm;
}

export interface SpecialSituationMessageVm{
    dateFrom: Date;
    dateTo: Date;
    message: string;
}

export enum EditorType {
  TermsOfUse = 0,
  BlockedAccount = 1,
  SpecialMessage = 2
}
